module.exports = _.defer;


//////////////////
// WEBPACK FOOTER
// external "_.defer"
// module id = 603
// module chunks = business-manager/shoutout-popup shoutout/shoutout full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile dashboard/dashboard business-manager/video-library-page widget/widget